import React from "react";

export default function SQLServer_FLOOR() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_FLOOR</h1>
      <p>This is the SQLServer_FLOOR component generated from the SQL JSON.</p>
    </div>
  );
}
